import React from 'react';
import { LayoutDashboard, Users, Activity, FileText } from 'lucide-react';
interface ViewSwitcherProps {
  currentView: string;
  onViewChange: (view: string) => void;
}
export function ViewSwitcher({
  currentView,
  onViewChange
}: ViewSwitcherProps) {
  const views = [{
    id: 'overview',
    label: 'Command Center',
    icon: LayoutDashboard
  }, {
    id: 'processors',
    label: 'Processor Workload',
    icon: Users
  }, {
    id: 'pipeline',
    label: 'Pipeline Flow',
    icon: Activity
  }, {
    id: 'conditions',
    label: 'Conditions Matrix',
    icon: FileText
  }];
  return <div className="flex bg-slate-100 p-1 rounded-lg border border-slate-200" data-id="element-309">
      {views.map(view => {
      const Icon = view.icon;
      const isActive = currentView === view.id;
      return <button key={view.id} onClick={() => onViewChange(view.id)} className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${isActive ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700 hover:bg-slate-200/50'}`} data-id="element-310">
            <Icon className={`w-4 h-4 ${isActive ? 'text-blue-600' : ''}`} data-id="element-311" />
            {view.label}
          </button>;
    })}
    </div>;
}